module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_loading.c7f6c242.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_loading.svg
// module id = 3195
// module chunks = 0